<template>
	<div :style="shu.yangshi" class="zidingyi_qiehuandianpu box_show">
		<div class="zidingyi_qiehuandianpu_left">
			<img :src="shu.shu.tu" alt="" style="width:40px;height: 40px;border-radius: 50%;" :style="yangshi" v-if="shu.shu">
			<div class="zidingyi_qiehuandianpu_left2">
				<div :style="yangshis">{{shu.shu.ming}}</div>
				<div>
					<img  src="https://limitao.myuan.cn/gongyong/shangchuan/tu/16/2019/11/lZ7RA4s5R48INLdAaAN8LNAaAal0NI.png" class="laba" alt="" >
					<span class="gonggao" :style="yangshis2">大麦大麦大麦</span>
				</div>
			</div>
		</div>
		<div class="lianxita">联系他</div>
	</div>
</template>

<script>
	export default {
		name: 'qiehuandianpu',
		data() {
			return {
				image: 'https://limitao.myuan.cn/gongyong/shangchuan/tu/16/2019/11/F4U68j7N72b664662lm82U9CEl48C4.jpg',
				yangshi: '',
				yangshis:'',
				yangshis2:''
			}
		},
		props: {
			shu: {
				type: Object,
				default () {
					return {
						wenzi: '输入文字',
						yangshi: {}
					}
				}
			}
		},
		mounted() {
			if (!this.shu.shu) {
				this.$set(this.shu, 'shu', {
					tu: 'https://limitao.myuan.cn/gongyong/shangchuan/tu/16/2019/11/F4U68j7N72b664662lm82U9CEl48C4.jpg',
					ming:'马云',
					tubiao:'',
					url: ''
				})
			}
			if (!this.shu.yangshi) {
				this.$set(this.shu, 'yangshi', {})
			}
		},
		watch: {
			'shu.yangshi.width': function() {
				this.Ys();
			},
			'shu.yangshi.height': function() {
				this.Ys();
			}
		},
		methods: {
			Ys() {
				this.yangshi = "";
				var px = '';
				if (this.shu.yangshi.width) {
					px = (this.shu.yangshi.width > 0) ? (this.shu.yangshi.width + 'px') : this.shu.yangshi.width;
					this.yangshi += "width:" + px + ";";
				}
				if (this.shu.yangshi.height) {
					
					px = (this.shu.yangshi.height > 0) ? (this.shu.yangshi.height + 'px') : this.shu.yangshi.height;
					this.yangshi += "height:" + px + ";";
				}
					console.log(this.yangshi)
			}
		}
	}
</script>

<style>
</style>
